import React, { useState, useRef, useEffect } from "react";
import { DefaultImageBaseurl, endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { FaCoins } from "react-icons/fa";
import CreateLoyalty from "./CreateLoyalty";
import { AiOutlineEdit } from "react-icons/ai";
import { Delete } from "@mui/icons-material";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Loyalty = () => {
  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [createLoyalty, setCeateLoyalty] = useState(false);
  const [editData, setEditData] = useState({});

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchVipPackage();
  }, []);

  const fetchVipPackage = async () => {
    let url = `${endPoints.api.GET_VIP_PACKAGES}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const DeletePacakage = (id) => {
    setIsLoading(true);
    let url = `${endPoints.api.DELTE_VIP_PACKAGE}/${id}`;
    deleteData(url)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.status == "success") {
          SuccesToast("Vip package Deleted Successfully.");
          fetchVipPackage();
        } else {
          ErrorToast(response?.data?.message);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const onClose = () => {
    setCeateLoyalty(false);
    fetchVipPackage();
  };
  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Loyalty
                  </h3>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setEditData({});
                      setCeateLoyalty(true);
                    }}
                  >
                    Add Loyalty Level
                  </Button>
                </div>
              </div>
              <CreateLoyalty
                open={createLoyalty}
                onClose={onClose}
                editData={editData}
              />

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table sticky table custom pagination table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Vip Level</TableCell>
                            <TableCell align="center">Bonus Boost</TableCell>
                            <TableCell align="center">Gift delivery</TableCell>
                            <TableCell align="center">
                              Cash Redemption
                            </TableCell>
                            <TableCell align="center">
                              Exclusive Games
                            </TableCell>
                            <TableCell align="center">Deposit Required ($)</TableCell>
                            <TableCell align="center">Birthday Bonus</TableCell>
                            <TableCell align="center">
                              Withdrawl Limit
                            </TableCell>
                            <TableCell align="center">Luxury Reward</TableCell>
                            <TableCell align="center">
                              Rakeback %
                            </TableCell>
                            <TableCell align="center">Free Spin</TableCell>
                            <TableCell align="center">Level</TableCell>
                            <TableCell align="center">Vip Access</TableCell>
                            <TableCell align="center">Image</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row?.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">
                                {row?.packagename}
                              </TableCell>
                              <TableCell align="center">
                                {row?.weekly_boost}
                              </TableCell>
                              <TableCell align="center">
                                {row?.gift_delivery}
                              </TableCell>
                              <TableCell align="center">
                                {row?.cash_redemption}
                              </TableCell>
                              <TableCell align="center">
                                {row?.exclusive_games == "1" ? "Yes" : "No"}
                              </TableCell>
                              <TableCell align="center">
                                {row?.deposit_required}
                              </TableCell>
                              <TableCell align="center">
                                {row?.birthday_bonus}
                              </TableCell>
                              <TableCell align="center">
                                {row?.withdrawl_limit}
                              </TableCell>
                              <TableCell align="center">
                                {row?.luxury_rewards == "1" ? "Yes" : "No"}
                              </TableCell>
                              <TableCell align="center">
                                {row?.rakeback_percentage}
                              </TableCell>
                              <TableCell align="center">
                                {row?.free_spins}
                              </TableCell>
                              <TableCell align="center">{row?.level}</TableCell>
                              <TableCell align="center">
                                {row?.vip_club_access == "1" ? "Yes" : "No"}
                              </TableCell>
                              <TableCell align="center">
                                <img
                                  src={`${DefaultImageBaseurl}${row?.levelimage}`}
                                  style={{ height: "50px" }}
                                />
                              </TableCell>
                              <TableCell align="center">
                              <div style={{display:"flex",gap:"5px"}}>
                                {
                                  <AiOutlineEdit
                                    size={20}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setCeateLoyalty(true);
                                      setEditData(row);
                                    }}
                                  />
                                }
                                {
                                  <span
                                    onClick={() => {
                                      DeletePacakage(row.id);
                                    }}
                                    style={{ cursor: "pointer",marginRight:"7px" }}
                                  >
                                    <Delete />
                                  </span>
                                }
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        {/* <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter> */}
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loyalty;
